var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0839 0.364C18.9211 0.13475 18.6569 0 18.3751 0H9.62514C9.34339 0 9.07914 0.13475 8.91464 0.364C8.75014 0.5915 8.70639 0.8855 8.79564 1.1515L10.5456 6.4015C10.6646 6.7585 10.9989 7 11.3751 7H16.6251C17.0014 7 17.3356 6.7585 17.4546 6.40325L19.2046 1.15325C19.2939 0.8855 19.2501 0.5915 19.0839 0.364ZM15.9951 5.25H12.0051L10.8396 1.75H17.1624L15.9951 5.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9774 20.7982L17.4774 5.92323C17.3672 5.45423 16.9017 5.16373 16.4257 5.27223C15.9532 5.38423 15.6627 5.85498 15.7747 6.32573L19.1609 20.7265L14.0002 25.8872L8.83769 20.7265L12.2274 6.32573C12.3377 5.85498 12.0454 5.38423 11.5764 5.27398C11.1057 5.16373 10.6332 5.45423 10.5229 5.92498L7.02294 20.8C6.95294 21.094 7.04044 21.4055 7.25569 21.619L13.3807 27.744C13.5522 27.9137 13.7762 27.9995 14.0002 27.9995C14.2242 27.9995 14.4482 27.9137 14.6197 27.7422L20.7447 21.6172C20.9582 21.4037 21.0474 21.0922 20.9774 20.7982Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTie);
export default __webpack_public_path__ + "static/media/tie.6e9b347527f1b7ea0b92220efab3cc4b.svg";
export { ForwardRef as ReactComponent };